<template>
  <div class="post post-medium">
    <div class="thumbr">
      <router-link :to="{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }" class="afterglow post-thumb">
        <span class="play-btn-border" title="Play"><i class="fa fa-play-circle headline-round" aria-hidden="true"></i></span>
        <div class="cactus-note ct-time font-size-1"><span>{{ video.durationString }}</span></div>
        <img class="img-responsive" :src="video.pictures.sizes[5].link" alt="#">
      </router-link>
    </div>
    <div class="infor">
      <h4>
        <router-link :to="{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }" class="title">
          {{ video.shortTitle }}
        </router-link>
      </h4>
      <span class="posts-txt" title="Likes"></span>
      <div class="ratings">
        <p>{{ video.date }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SingleVideo',
    props: {
      video: { type: Object, required: true },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/Singlevideo.vue